<template>
  <div class="room-bulletinboard-message">
    <div id="pinned-title"><span>サンプル百貨店からの大切なお知らせ</span></div>
    <div class="row row-custom">
      <div class="admin">
        <div class="card card-custom">
          <div class="card-header">
            <div class="card-header-content">
              <span class="nickname">{{ message.nickname | base64Decode | mask }}</span>
              <span class="timestamp">{{ message.timestamp | formatTimestamp }}</span>
            </div>
            <RoomMessageReaction
              :reaction="reaction"
              :message_id="message_id"
              :is_login="is_login"
              :current_user_id="current_user_id"
            />
          </div>
          <div class="card-content">{{ message.text }}</div>
        </div>
      </div>
    </div>
    <div class="divider"></div>
  </div>
</template>

<script>
import RoomMessageReaction from "./RoomMessageReaction";
import moment from "moment-timezone";

export default {
  name: "RoomMessageItem",
  components: {
    RoomMessageReaction
  },
  props: {
    message_id: String,
    message: Object,
    reaction: Object,
    is_login: Boolean,
    current_user_id: String
  },
  filters: {
    formatTimestamp: function(timestamp) {
      return moment(timestamp)
        .tz("Asia/Tokyo")
        .format("HH：mm");
    },
    base64Decode: function(encoded) {
      return decodeURIComponent(escape(window.atob(encoded)));
    },
    mask: function(text) {
      if (text.length < 13) {
        return text;
      }
      return text.substring(0, 12) + "…";
    }
  }
};
</script>

<style lang="scss" scoped>
.room-bulletinboard-message{
  background-color: white;
}
#pinned-title {
  padding-top: 5px;
  padding-bottom: 2px;
  margin-left: 10px;
  font-size: 12px;
  color:#999999
}
.row-custom {
  margin: 0px;
  padding-bottom: 10px;
  $radius: 15px;
  .card-custom {
    margin: auto;
    border-radius: $radius;
    box-shadow: 0px 2px 2.15px 0.4px rgba(0, 0, 0, 0.2);
    background-color: #ffffff;
    .card-header {
      display: flex;
      justify-content: space-between;
      border-radius: $radius $radius 0px 0px;
      height: 53px;
      background-color: #eeece7;
      .card-header-content {
        .nickname {
          margin-top: 15px;
          margin-left: 15.5px;
          display: block;
          font-family: HiraKakuPro-W6;
          line-height: 0.93;
          color: #333333;
          font-size: 14px;
        }
        .timestamp {
          margin-top: 7px;
          margin-left: 16.5px;
          display: block;
          font-family: HiraKakuPro-W3;
          font-size: 10px;
          line-height: 1.4;
          color: #999999;
        }
      }
    }
    .card-content {
      padding: 15px 32.5px 15px 17px;
      border-radius: 0px 0px $radius $radius;
      font-family: HiraKakuPro-W3;
      font-size: 16px;
      line-height: 2;
      color: #333333;
      word-break: break-all;
    }
  }
  .admin {
    .card-header {
      background-color: #ffef7a;
    }
    .card-content {
      background-color: #ffffcc;
    }
  }
}
.divider {
  background-color:#c4c4c4;
  box-shadow: 0px 0.5px 0.5px 0.1px rgba(53, 53, 53, 0.2);
}
</style>
